import { post, get } from "../axiosClient";
import { searchParams, searchResponse, IBannerResponse, IBannerSearchParams } from "./type";

const bannerServices = {
  searchBanner(params: searchParams): Promise<searchResponse> {
    return post("/nfts/search", params);
  },

  async getBanners(params: IBannerSearchParams): Promise<IBannerResponse> {
    const response = await get("/banners/search", { params });
    return response.data;
  },
};

export default bannerServices;
